import './ClosedRequests.css';
import Table from 'react-bootstrap/Table';
import ClosedRequestsRow from '../ClosedRequestsRow/ClosedRequestsRow';
import {QuestionCircle} from 'react-bootstrap-icons';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
function ClosedRequests(props){
        const dispatch = useDispatch();

    const request = useSelector((store) => store.requestReducer.closed);
        const requestNewest = useSelector((store) => store.requestNewestReducer.closed);
    const requestName = useSelector((store) => store.requestNameReducer.closed);
    const [searchTerm, setSearchTerm ] = useState("");
    const [searchResults,setSearchResult] = useState([]);
    const inputEl = useRef("");
          const searchHandler = (searchTerm) =>{
        setSearchTerm(searchTerm);
        if(searchTerm !==""){
            const newClientList = request.filter((request)=>{
              return Object.values(request).join(" ").toLowerCase().includes(searchTerm.toLowerCase());
            })
            setSearchResult(newClientList);
            console.log("test"+searchResults);
        }
        else{
            setSearchResult(request);
             console.log("test"+searchResults);
        }
        }

    const getSearchTerm = () =>{
      
        searchHandler(inputEl.current.value);
    }
              useEffect(() => {
     

  
  }, []);
    return(
        <>
          <input ref={inputEl} size="40" type="text" value={searchTerm} onChange={getSearchTerm} placeholder="type to search"></input> <button onClick ={(e) => (setSearchTerm(""))}>CLEAR</button>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th className="text-center">
                        Referral Date
                    </th>
                    <th className="text-center">
                        Appointment
                    </th>
                    <th className="text-center">
                        Client Name
                    </th>
                    <th className="text-center">
                        Requested Items
                    </th>
                    <th className="text-center">
                        Referral Agency
                    </th>
                    <th className="text-center">
                        Actions
                    </th>
                </tr>
            </thead>
                                  {searchTerm.length<1?
            <>
            {props.sortValue == 0 ?
            <ClosedRequestsRow searchResults = {requestNewest}/>
            :
            <>
                {props.sortValue == 1 ?
                    <ClosedRequestsRow searchResults = {request}/>
                    :
                    <>
                        {props.sortValue == 2?
                        <ClosedRequestsRow searchResults = {requestName}/>
                            :
                            <> </> 
                        }
                    </>
                }
            </>
            }
            </>
         
            :
             <ClosedRequestsRow
            
             searchResults = {searchResults}
        
             
             />
            
            }
        </Table>
        </>
    );
}

export default ClosedRequests;